$(function () {
  // custom date
  $("[name='fix-date']").click(function () {
    const fixDateValue = $(this).val();
    if (fixDateValue === "none-fix-date") {
      $("#must-fix-date").hide();
      // 設定リセット
      $(".uiDeliveryDateVal,.uiDeliveryDayVal,.uiDeliveryTimeVal").removeAttr("value");
      $(".ui-state-active").removeClass("ui-state-active");
      $("select.deliveryTime").children().not(":first").remove();
      $('[name="checkout"]').removeClass("disable");
    } else if (fixDateValue === "fix-date") {
      $('[name="checkout"]').addClass("disable");
    }
  });

  window.onpageshow = function (event) {

    if ($('[id=form__with-egift]').prop('checked')) {
      //$("#form__none-egift").prop('checked', true);
      $('.form__fix-date-wrapper').hide();
      $('.form__e-gift-option-wrapper').show();
    }
    else if ($("[name='fix-date']").length > 0) {
      // ブラウザバック時にも配送指定なしにするため
      $("#form__none-fix-date").click();
    }

  };

  // 日付指定カレンダーが表示されるのが完了され場合
  const target = document.getElementById("delivary-calender");
  const calender_observer = new MutationObserver((records) => {
    // 日付指定で日付の変化検知と、時間の変化検知
    const date_target = document.getElementsByClassName("uiDeliveryDateVal")[0];
    const time_target = document.getElementsByClassName("uiDeliveryTimeVal")[0];
    const hidden_observer = new MutationObserver((delivery_records) => {
      delivery_records.forEach(function (record) {
        if ($(record.target).hasClass("uiDeliveryTimeVal")) {
          const time = $(record.target).val();
          if (time.length > 0) {
            $('[name="checkout"]').removeClass("disable");
            $("#must-fix-date").hide();
          }else{
            if ($("#form__with-fix-date").prop('checked')) {
              $('[name="checkout"]').addClass("disable");
              $("#must-fix-date").show();
            }
          }
        }
      });
    });
    if (date_target) {
      hidden_observer.observe(date_target, {
        attributes: true,
      });
    }
    if (time_target) {
      hidden_observer.observe(time_target, {
        attributes: true,
      });
    }
  });
  if($(target).length){
    calender_observer.observe(target, {
      childList: true,
    });
  }
});
